export enum MIXPANEL_METHODS {
    Track = 'track',
    Identify = 'identify',
    PeopleSet = 'peopleSet',
    Reset = 'reset',
}

export enum MIXPANEL_EVENTS {
    // INITIAL USER DETAILS EVENTS
    NAME_EMAIL_ADDITION_SUCCESS = 'name_email_addition_success',
    NAME_EDIT_SUCCESS = 'name_edit_success',
    EMAIL_EDIT_SUCCESS = 'email_edit_success',
    PHONE_EDIT_SUCCESS = 'phone_edit_success',

    // LOGIN EVENTS
    LOGIN_VIA_BROKER = 'login_via_broker',
    LOGIN_SUCCESS_GOOGLE = 'login_success_google',                      // Feature Disabled
    LOGIN_SUCCESS_PHONE_NUMBER = 'login_success_phone_number',
    LOGIN_SUCCESS_EMAIL = 'login_success_email',
    LOGIN_SUCCESS_APPLE = 'login_success_apple',
    LOGIN_PRIVACY_POLICY = 'login_privacy_policy',
    LOGIN_TERMS_CONDITIONS = 'login_terms_conditions',
    LOGIN_ALL_BROKER_LIST = 'login_all_broker_list',

    // OTP LIMITING
    WRONG_OTP_ATTEMPT = 'wrong_otp_attempt',
    RESEND_OTP = 'resend_otp',
    USER_BLOCKED = 'user_blocked',

    // HEADER EVENTS
    WHATS_NEW = 'whats_new',
    OPEN_NOTIFICATIONS = 'home_notifications',
    NAVIGATE_BOOKS = 'home_books',
    PANIC_CONTROL = 'panic_control',
    MANAGE_INDICES = 'home_manage_index_watch',
    NAVIGATE_PORTFOLIOS = 'portfolios',
    NAVIGATE_AI_TAB = 'AI_tab',
    NAVIGATE_STRATEGY_BUILDER = 'strategy_builder',
    NAVIGATE_MARGIN_CALCULATOR = 'margin_calc',
    NAVIGATE_PAY_OFF_CURVE = 'pay_off_curve',
    NAVIGATE_WATCHLIST = 'watchlist',

    // DASHBOARD EVENTS
    VIEW_FUNDS_SUMMARY = 'view_funds_summary',
    VIEW_EARNINGS = "view_earnings",
    MANAGE_BROKERS = 'manage_brokers',
    DEFAULT_AI_PROMPT = 'default_ai_prompt',

    // PORTFOLIO / STRATEGY EVENTS
    OPEN_STRATEGY_OVERVIEW = 'open_strategy_overview',
    OPEN_STRATEGY_DETAIL = 'stg_books_or_details',
    PORTFOLIO_SECTION = 'portfolio_section',
    COPY_CREATED = 'copy_created',
    SET_EXIT_PARAMS = 'set_exit_params',
    PORTFOLIO_DELETED = 'delete_portfolio',
    PORTFOLIO_BOOKMARKED = 'bookmark_portfolio',
    REDUCE_MULTIPLIER = 'reduce_multiplier',

    // PORTFOLIO SEARCH & FILTER EVENTS
    FILTER_PORTFOLIO = 'filter_portfolio',

    // STRATEGY BUILDER EVENTS
    PORTFOLIO_SAVED = 'saved_portfolio',

    // PORTFOLIO MANUAL SWITCH EVENTS
    MANUAL_SWITCH_SUCCESS = 'manual_switched_success',

    // DEPLOYMENT EVENTS
    DEPLOY_STRATEGY_SUCCESS = 'deploy_strategy_success',
    DEPLOY_STRATEGY_FAILURE = 'deploy_strategy_failure',
    UNDEPLOY_STRATEGY_SUCCESS = 'undeploy_strategy_success',
    UNDEPLOY_STRATEGY_FAILURE = 'undeploy_strategy_failure',

    // API ERROR EVENTS (semantic events for analytics segmentation)
    API_ERROR = 'api_error', // other errors

    // SOCKET EVENTS
    SOCKET_CONNECTED = 'socket_connected',
    SOCKET_ERROR = 'socket_error',
    SOCKET_AUTH_FAILED = 'socket_auth_failed',
    SOCKET_LOGOUT_FORCED = 'socket_logout_forced',
    SOCKET_MESSAGE_ERROR = 'socket_message_error',

    // BOOKS EVENTS
    EXPORT_BOOKS = 'export',

    // PROFILE EVENTS
    MY_PROFILE = 'profile_my_profile',
    PROFILE_GLOBAL_EXIT_PARAMS = 'profile_global_exit_params',
    UPGRADE_PLAN = 'upgrade_plan',
    PROFILE_LOGOUT = 'profile_logout',

    // ACTIVE SESSION EVENTS
    VISIT_ACTIVE_SESSIONS = 'active_sessions',
    LOGOUT_ALL_SESSIONS = 'logout_all_sessions',

    // PNL REPORT EVENTS
    VIEW_PNL_REPORTS = 'pnl_reports',
    PNL_FILTER_APPLIED = 'pnl_filter_applied',
    DOWNLOAD_PNL_REPORTS = 'download_pnl_reports',
    EXPORT_PDF = 'export_pdf',
    DEPLOYED_MARGIN_CHECK = 'deployed_margin_check',

    // GLOBAL EXIT EVENTS
    GLOBAL_SETTING_SAVE_CHANGES = 'global_setting_save_changes',
    STRATEGY_RUNTIME_EDIT_SUCCESS = 'stg_runtime_edit_success',

    // WATCHLIST EVENTS
    VIEW_CHART = 'view_chart',
    SHOW_DEPTH = 'show_depth',
    ADD_SYMBOL_TO_MW = 'add_symbol',
    REMOVE_SYMBOL_FROM_MW = 'remove_symbol',

    // ONE AI EVENTS
    AI_NEW_CHAT = 'ai_new_chat',
    AI_THREAD_CREATION_SUCCESS = 'ai_thread_creation_success',
    AI_CHAT_STAR = 'ai_chat_star',
    AI_CHAT_DELETE = 'ai_chat_delete',
    AI_CHAT_FOLLOW_UP_SUGGESTION = 'ai_chat_follow_up_suggestion',
    AI_CHAT_SEND_MESSAGE = 'ai_chat_send_message',
    AI_CHAT_STOP_RESPONSE = 'ai_chat_stop_response',
    AI_CHAT_TRY_AGAIN = 'ai_chat_try_again',
    AI_VIA_HOMEPAGE = 'ai_homepage',
    AI_SAVE_PORTFOLIO = 'ai_save_portfolio',
    AI_VALIDATE_YAML = 'ai_validate_yaml',

    // MARKET CONTENT EVENTS
    OPEN_HELP = 'open_help',
    VIEW_USER_MANUAL = 'view_user_manual',
    WATCH_VIDEOS = 'videos',
    CHECK_FAQS = 'faq',

    // BACKTEST EVENTS 
    PORTFOLIO_BACKTEST_SUCCESS = 'portfolio_backtest_success',

    // PLAN & PRICING EVENTS
    AUTOPAY_ENABLE = 'autopay_enable',
    AUTOPAY_DISABLE = 'autopay_disable',
    PLANS_TRANSACTION_HISTORY = 'plans_transaction_history',
    PLAN_UPGRADES = 'plan_upgrades',
    MANAGE_SUBSCRIPTIONS = 'manage_subscriptions',
    RETAIN_MULTIPLIER = 'retain_multiplier',

    // MULTI BROKER EVENTS
    ADD_BROKER = 'add_broker',
    DELETE_BROKER = 'delete_broker',
    CONNECT_BROKER = 'connect_broker',
    BROKER_TERMINATE_STRATEGY = 'broker_terminate_strategy',
    RE_LOGIN_BROKER = 're_login_broker',

    // STATIC IP EVENTS
    VIRTUAL_ALGO_SPACE_DASHBOARD = "virtual_algo_space_dashboard",
    VIRTUAL_ALGO_SPACE_ASSIGNMENT_SUCCESS = "virtual_algo_space_assignment_success",
}

/** API error type strings for single-event Mixpanel tracking. Use getFromStatus() for status-to-type mapping. */
export class ApiErrorTypes {
    static readonly OFFLINE = 'offline_api_error';
    static readonly BAD_REQUEST = 'bad_request_api_error';
    static readonly UNAUTHORIZED = 'unauthorized_api_error';
    static readonly FORBIDDEN = 'forbidden_api_error';
    static readonly USER_LOCKED = 'user_locked_error';
    static readonly NOT_FOUND = 'not_found_api_error';
    static readonly RATE_LIMITED = 'rate_limited_api_error';
    static readonly SERVER = 'server_error';
    static readonly SERVICE_UNAVAILABLE = 'service_unavailable';
    static readonly CREDITS_EXHAUSTED = 'credits_exhausted';
    static readonly FEATURE_UNAVAILABLE = 'feature_not_available';
    static readonly CONNECTIVITY_ERROR = 'connectivity_error';
    static readonly CONNECTION_ABORTED = 'connection_abort_error';
    static readonly CLIENT_4XX = 'client_4xx_error';
    static readonly SERVER_5XX = 'server_5xx_error';
    static readonly OTHER = 'other_api_error';

    private static readonly STATUS_MAP: Readonly<Record<number, string>> = {
        400: ApiErrorTypes.BAD_REQUEST,
        401: ApiErrorTypes.UNAUTHORIZED,
        402: ApiErrorTypes.CREDITS_EXHAUSTED,
        403: ApiErrorTypes.FORBIDDEN,
        404: ApiErrorTypes.NOT_FOUND,
        429: ApiErrorTypes.RATE_LIMITED,
        500: ApiErrorTypes.SERVER,
        502: ApiErrorTypes.SERVICE_UNAVAILABLE,
        503: ApiErrorTypes.SERVICE_UNAVAILABLE,
        504: ApiErrorTypes.SERVICE_UNAVAILABLE,
    };

    static getFromStatus(status: number): string {
        if (ApiErrorTypes.STATUS_MAP[status]) return ApiErrorTypes.STATUS_MAP[status];
        if (status >= 400 && status < 500) return ApiErrorTypes.CLIENT_4XX;
        if (status >= 500 && status < 600) return ApiErrorTypes.SERVER_5XX;
        return ApiErrorTypes.OTHER;
    }
}